import { Button, LinkButton } from "@flash-tecnologia/hros-web-ui-v2";
import { useCallback } from "react";
import { Box } from "src/components/core-components/atoms/Box/box";
import { Focused } from "src/components/core-components/templates/Focused/focused";
import { useNavigate } from "react-router-dom";
import { TrackingEvents } from "./types";
import { useGetSetup, useSession } from "@/hooks";

import { ProgressBarFullWidth } from "@/components/core-components";
import { Overview } from "./steps/Overview/overview";
import { setEventTracking } from "@/utils";
import { WorkflowLoading } from "./components/WorkflowLoading/workflow-loading";
import dispatchToast from "@/utils/dispatch-toast";

interface OverviewWorkflowProps {
  onNext: () => void;
}

export const OverviewWorkflow: React.FC<OverviewWorkflowProps> = ({
  onNext: onNextWorkflow,
}) => {
  const navigate = useNavigate();
  const { companyId } = useSession();
  const { setup, isLoading } = useGetSetup(companyId, {
    onError: () => {
      dispatchToast({
        type: "error",
        content: "Ocorreu um erro ao carregar a configuração",
      });
      navigate("/home");
    },
  });

  const onNext = useCallback(() => {
    setEventTracking(TrackingEvents.SETUP_OVERVIEW_CONTINUE_CLICKED);
    onNextWorkflow();
  }, [navigate]);

  const onContinueLaterClick = useCallback(() => {
    setEventTracking(TrackingEvents.SETUP_OVERVIEW_CONTINUE_LATER_CLICKED);
    navigate("/home");
  }, [navigate]);

  if (isLoading || !setup) {
    return <WorkflowLoading />;
  }

  return (
    <Focused.Root fullScreen>
      <Focused.Header>
        <Focused.Title color="neutral.30">
          Configuração da plataforma
        </Focused.Title>
      </Focused.Header>
      <ProgressBarFullWidth.Root>
        <ProgressBarFullWidth.ActiveBar percent={0} />
        <ProgressBarFullWidth.GuideLine />
      </ProgressBarFullWidth.Root>
      <Focused.Main>
        <Overview setup={setup} />
      </Focused.Main>
      <Focused.Footer>
        <Box justifyContent="space-between" $width="100%">
          <LinkButton
            variant="neutral"
            size="medium"
            underlined={false}
            onClick={onContinueLaterClick}
          >
            Continuar mais tarde
          </LinkButton>
        </Box>
        <Box gap="xs2">
          <Button variant="primary" size="medium" onClick={onNext}>
            Começar
          </Button>
        </Box>
      </Focused.Footer>
    </Focused.Root>
  );
};
